<template>
  <nav
    class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white"
    id="sidenav-main"
  >
    <div class="container-fluid">
      <!--Toggler-->
      <navbar-toggle-button @click.native="showSidebar"> </navbar-toggle-button>
      <router-link class="navbar-brand" to="/">
        <img
          :src="logo"
          class="navbar-brand-img"
          style="max-height : 6rem;"
          alt="logo-bukakasir"
        />
      </router-link>

      <slot name="mobile-right">
        <ul class="nav align-items-center d-md-none">
          <li class="nav-item">
            <a class="nav-link nav-link-icon" @click="$router.push('/kasir')">
              <i class="fas fa-shopping-bag" style="color : black;"></i>
            </a>
          </li>
          <!-- <base-dropdown
            v-if="$store.state.access_level"
            class="nav-item"
            menu-on-right
            tag="li"
            title-tag="a"
          >
            <a
              slot="title-container"
              class="nav-link nav-link-icon"
              href="#"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-store-alt" style="color : black;"></i>
            </a>

            <a
              class="dropdown-item"
              v-for="tk in toko"
              :key="tk.id"
              :class="{ disabled: !tk.isPaidoff }"
              @click="pindahtoko(tk.id)"
              >{{ tk.nama }}
              <i
                v-if="tk.id == $store.state.tokoNow"
                class="ni ni-check-bold"
              ></i
            ></a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="$router.push('/tambahtoko')"
              ><i class="ni ni-fat-add"></i>Tambah Toko Baru</a
            >
          </base-dropdown> -->
          <base-dropdown class="nav-item" menu-on-right tag="li" title-tag="a">
            <div slot="title-container" class="nav-link" href="#" role="button">
              <div class="media align-items-center">
                <span
                  class="avatar avatar-sm rounded-circle"
                  style="background-color:white;"
                >
                  <img
                    alt="Image placeholder"
                    :src="$config.base_url + 'img/icons/BukaKasir.png'"
                  />
                </span>
              </div>
            </div>

            <div class=" dropdown-header noti-title">
              <h6 class="text-overflow m-0">{{ $store.state.name }}</h6>
            </div>
            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-single-02"></i>
              <span>Profile</span>
            </router-link>
            <router-link to="/absen" class="dropdown-item">
              <i class="ni ni-active-40"></i>
              <span>Absen</span>
            </router-link>
            <router-link
              to="/settingtoko"
              v-if="$store.state.access_level"
              class="dropdown-item"
            >
              <i class="ni ni-settings-gear-65"></i>
              <span>Setting Toko</span>
            </router-link>
            <div class="dropdown-divider"></div>
            <a @click="logout()" class="dropdown-item">
              <i class="ni ni-user-run"></i>
              <span>Logout</span>
            </a>
          </base-dropdown>
        </ul>
      </slot>
      <slot></slot>
      <div
        v-show="$sidebar.showSidebar"
        class="navbar-collapse collapse show"
        id="sidenav-collapse-main"
      >
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img :src="logo" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button
                @click.native="closeSidebar"
              ></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"> </slot>
        </ul>
        <!--Divider-->
        <!-- <hr class="my-3"> -->
        <!--Heading-->
        <!-- <h6 class="navbar-heading text-muted">Documentation</h6> -->
        <!--Navigation-->
        <!-- <ul class="navbar-nav mb-md-3">
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://www.creative-tim.com/learning-lab/bootstrap-vue/alerts/argon-dashboard">
                            <i class="ni ni-spaceship"></i> Getting started
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://www.creative-tim.com/learning-lab/bootstrap-vue/colors/argon-dashboard">
                            <i class="ni ni-palette"></i> Foundation
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://www.creative-tim.com/learning-lab/bootstrap-vue/alerts/argon-dashboard">
                            <i class="ni ni-ui-04"></i> Components
                        </a>
                    </li>
                </ul> -->
      </div>
    </div>
  </nav>
</template>
<script>
import NavbarToggleButton from "@/components/NavbarToggleButton";
import update from "@/mixins/update";

export default {
  name: "sidebar",
  components: {
    NavbarToggleButton
  },
  mixins: [update],
  props: {
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item"
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  data() {
    return {
      toko: [],
      logo: ""
    };
  },
  created() {
    this.logo = this.$config.base_url + "img/icons/BukaKasir.png";
  },
  methods: {
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },
    pindahtoko(toko_id) {
      var self = this;
      if (toko_id == this.$store.state.tokoNow) {
        this.$toast.info("Anda sudah berada pada toko tersebut", {
          position: "top-center",
          timeout: 3000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
      } else {
        self
          .$axios({
            method: "GET",
            url: self.$config.url_api + "toko/pindah_toko/" + toko_id,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/json",
              Authorization: "Bearer " + self.$cookies.get("code")
            }
          })
          .then(function(response) {
            if (response.data.status == "ok") {
              if (self.$route.path == "/settingtoko") {
                self.$router.go();
              } else {
                self.$router.push("settingtoko");
              }

              self.tokonow = toko_id;
              self.$store.state.tokoNow = toko_id;
            }
          })
          .catch(error => {
            // console.log(error)
          });
      }
    },
    logout() {
      var self = this;
      self
        .$axios({
          method: "POST",
          url: self.$config.url_api + "logout",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + self.$cookies.get("code")
          }
        })
        .then(function(response) {
          // console.log(response.data)
          if (response.data.status == "ok") {
            self.$cookies.remove("code");
            location.href = self.$config.base_url;
          }
        })
        .catch(error => {
          // console.log(error)
        });
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
